<template>
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-sm-12 col-md-9">
                    <h3 class="mb-0">Open Order Lines</h3>
                </div>
                <div class="col-sm-12 col-md-3 text-right">
                    <!-- <span class="add-button btn btn-action" @click="exportToExcel">Export To Excel</span> -->
                    <a
                        :href="'/export-report/' + currentLocation.id"
                        target="_blank"
                        class="add-button btn btn-action"
                        >Export To Excel</a
                    >
                </div>
            </div>
            <table
                class="table table-responsive table-striped border-bottom mt-2"
            >
                <thead class="thead-light">
                    <tr>
                        <th style="width: 10em">&nbsp;</th>
                        <th style="width: 9em">&nbsp;</th>
                        <th style="width: 15em">PO Number</th>
                        <th style="width: 10em">SKU</th>
                        <th>Name</th>
                        <th style="width: 10em" class="text-right">
                            Open Quantity
                        </th>
                        <th style="width: 10em" class="text-right">
                            Open Amount
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <template
                        v-for="report in orderLinesReport"
                        :key="report.id"
                    >
                        <tr>
                            <td colspan="7">
                                <div
                                    class="d-flex justify-content-between font-weight-bold"
                                >
                                    <div>
                                        ORDER:
                                        {{
                                            user.is_demo
                                                ? "ORD-12345"
                                                : report.order_number
                                        }}
                                        ({{
                                            $filters.dateFormat(
                                                report.order_date
                                            )
                                        }})
                                    </div>
                                    <div>
                                        ${{
                                            $filters.moneyFormat(
                                                report.order_total
                                            )
                                        }}
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="7" class="p-0">
                                <table class="table table-responsive m-0">
                                    <tbody>
                                        <tr
                                            v-for="rep in report.data"
                                            :key="rep.id"
                                        >
                                            <td style="width: 11em">
                                                {{
                                                    $filters.dateFormat(
                                                        rep.order_date
                                                    )
                                                }}
                                            </td>
                                            <td style="width: 11em">
                                                {{
                                                    user.is_demo
                                                        ? "ORD-12345"
                                                        : rep.order_number
                                                }}
                                            </td>
                                            <td style="width: 17em">
                                                {{
                                                    user.is_demo
                                                        ? "PO-12345"
                                                        : rep.po_number
                                                }}
                                            </td>
                                            <td style="width: 11em">
                                                {{ rep.sku }}
                                            </td>
                                            <td>{{ rep.name }}</td>
                                            <td
                                                style="width: 10em"
                                                class="text-right"
                                            >
                                                {{ rep.open_quantity }}
                                            </td>
                                            <td
                                                style="width: 12em"
                                                class="text-right"
                                            >
                                                ${{
                                                    $filters.moneyFormat(
                                                        rep.open_amount
                                                    )
                                                }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

export default {
    props: [],
    emits: [],
    components: {},
    setup() {
        const store = useStore();

        let user = computed(function () {
            return store.state.user;
        });

        let currentLocation = computed(function () {
            return store.state.currentLocation;
        });

        let orderLinesReport = computed(function () {
            return store.state.orderLinesReport;
        });

        onMounted(() => {});

        return {
            store,
            user,
            currentLocation,
            orderLinesReport,
        };
    },
    data() {
        return {};
    },
    computed: {},
    mounted() {
        console.log('this.currentLocation', this.currentLocation)
        this.store.dispatch("orderLinesReport", {
            location_id: this.currentLocation.id,
        });
    },
    methods: {
        exportToExcel() {
            this.store.dispatch("exportToExcel", {
                location_id: this.currentLocation.id,
            });
        },
    },
};
</script>
